module.exports = __webpack_public_path__ + "static/media/2019 Barcelona.05530919.jpg";